import React from 'react'
import { PrismicRichText } from '@prismicio/react'
import LiteYouTubeEmbed from 'react-lite-youtube-embed'
import 'react-lite-youtube-embed/dist/LiteYouTubeEmbed.css'

const Video = ({ id, title, slice }) => {
  if (!id && slice.video_url === null && slice.primary.video_url === null) return null

  let embed = slice?.primary.embed_video.embed_url || id

  if (slice?.primary.embed_video.title || slice?.primary.video_title.text) {
    title = slice?.primary.video_title.text || slice?.primary.embed_video.title
  }

  if (embed?.includes('watch')) {
    embed = embed.split('v=')[1]
    var ampersandPosition = embed.indexOf('&')
    if (ampersandPosition !== -1) {
      embed = embed.substring(0, ampersandPosition)
    }
  }
  if (embed?.includes('shorts')) {
    embed = embed.split('shorts/')[1]
  }
  if (embed?.includes('youtu.be/')) {
    embed = embed.split('youtu.be/')[1]
  }
  return (
    <section className='component-video mx-auto w-full max-w-screen-xl py-10 px-4'>
      {embed ? (
        <>
          {slice?.primary.title && (
            <div className='prose prose-xl mx-auto mb-8 text-center'>
              <PrismicRichText field={slice?.primary.title.richText} />
            </div>
          )}
          <div className='rounded bg-white p-2 shadow-md'>
            <LiteYouTubeEmbed id={embed} title={title} />
          </div>
        </>
      ) : (
        <>
          {slice.primary.video_title && (
            <div className='title'>
              <PrismicRichText field={slice.primary.video_title.richText} />
            </div>
          )}
          <video controls poster={slice.primary.video_poster.url}>
            <track kind='captions' />
            <source src={slice.video_link.url} type='video/mp4' />
            Your browser does not support the video tag
          </video>
        </>
      )}
    </section>
  )
}

export default Video
